import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Button, Typography } from "antd";
import { useAuth } from "../../../Context/AuthContext/AuthContext";
import { useLoader } from "../../../Context/LoaderContext/LoaderContext";
import JobApplicationService from "../../../Services/job.application.service";
import { useAppContext } from "../../../Context/AppContext/AppContext";
import { openNotification } from "../../../Components/Notification/Index";

interface JobPostCardProps {
  _id: string;
  title: string;
  position: string;
  description: string;
  slug: string;
  isApplied: boolean;
  isActive: boolean;
}

const getRandomTagVariant = () => {
  const variants = ["blue", "red", "orange"];
  return variants[Math.floor(Math.random() * variants.length)];
};

const JobPostCard: React.FC<JobPostCardProps> = ({
  _id,
  title,
  position,
  slug,
  description,
  isApplied,
  isActive,
}) => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useAuth();
  const { organization } = useAppContext();
  const { setLoading, setLoadingMessage } = useLoader();
  const jobApplicationService = new JobApplicationService();

  const handleNavigateToJobDetails = () => {
    navigate(`/${slug}/requirements`);
  };

  const handleApplyNow = async () => {
    if (!isUserLoggedIn) {
      const redirectUrl = `/${slug}/requirements?action=apply`;
      navigate(`/sign-in?redirect_url=${encodeURIComponent(redirectUrl)}`);
      return;
    }

    try {
      setLoading(true);
      setLoadingMessage("Submitting your application...");
      await jobApplicationService.sendJobApplication(
        _id,
        [],
        organization?.orgName || "Null Organization",
        title,
      );
      openNotification("success", "Application submitted successfully", "");
      navigate(`/${slug}/requirements`);
    } catch (error: any) {
      console.error("Error applying for job:", error);
    } finally {
      setLoading(false);
      setLoadingMessage(null);
    }
  };

  return (
    <div style={!isActive ? { filter: "grayscale(100%)" } : undefined}>
      <Badge.Ribbon
        text="closed"
        style={{ display: isActive ? "none" : undefined }}
      >
        <div className="job-listing__job-card">
          <div className="job-listing__job-card-header">
            <Typography.Title
              level={5}
              style={{ margin: 0 }}
            >
              {title}
            </Typography.Title>
            <Typography.Text
              className={`job-listing__job-card-tag job-listing__job-card-tag--${getRandomTagVariant()}`}
              style={{ margin: 0 }}
            >
              {position}
            </Typography.Text>
          </div>
          <Typography.Paragraph
            className="job-listing__job-card-desc"
          >
            {description}
          </Typography.Paragraph>
          <div className="job-listing__job-card-actions">
            <Button
              type="default"
              size="middle"
              block
              className="job-listing__job-card-btn"
              disabled={!isActive}
              onClick={handleNavigateToJobDetails}
            >
              {isApplied ? "View Application" : "Details"}
            </Button>

            {!isApplied && (
              <Button
                type="primary"
                size="middle"
                block
                disabled={!isActive}
                className={`job-listing__job-card-btn`}
                onClick={handleApplyNow}
              >
                Apply Now
              </Button>
            )}
          </div>
        </div>
      </Badge.Ribbon>
    </div>
  );
};

export default JobPostCard;
